<h3 mat-dialog-title>{{data.dialogTitle}}</h3>
<img (click)="closeDialog()" class="mat-close" src="/assets/images/payhoa/other/icon_close.svg">

<mat-dialog-content>
    <p *ngIf="data.dialogContent">
        {{data.dialogContent}}
    </p>
    <form [formGroup]="form">
        <div class="form-group">
            <label>
                Routing Number:
            </label>
            <input (blur)="searchForRoutingNumber()" formControlName="routingNumber" class="form-control  form-control-sm" maxlength="9" required/>
            <p class="mt-1 mb-0 text-success" *ngIf="selectedSearchResult && plaidSearchResults.length === 1">
                Matched to <strong>{{selectedSearchResult.name}}</strong>
            </p>
            <ng-container *ngIf="hasSearchedForRoutingNumber">
                <ng-container *ngIf="plaidSearchResults.length > 1">
                    <p class="mt-1 mb-2 text-success">
                        Multiple routing number matches found. Please select your banking institution below.
                    </p>
                    <div class="institution-list">
                        <ng-container *ngFor="let result of plaidSearchResults">
                            <button [class.btn-primary]="selectedSearchResult?.institutionId === result.institutionId"
                                    [class.btn-outline-secondary]="!(selectedSearchResult?.institutionId === result.institutionId)"
                                    [attr.data-institution-id]="result.institutionId"
                                    class="btn m-0"
                                    (click)="selectedSearchResult = result">
                                {{result.name}}
                            </button>
                        </ng-container>
                        <button [class.btn-primary]="selectedSearchResult === null"
                                [class.btn-outline-secondary]="!(selectedSearchResult?.institutionId === null)"
                                [attr.data-institution-id]="'none of the above'"
                                class="btn m-0"
                                (click)="selectedSearchResult = null">
                            None of the above
                        </button>
                    </div>
                </ng-container>
                <p class="mt-1 mb-0 text-warning" *ngIf="plaidSearchResults.length === 0">
                    We could not match that routing number to an institution supported by Plaid.
                    Transactions import will be disabled.
                </p>
            </ng-container>
            <lf-control-messages [control]="form.controls['routingNumber']"></lf-control-messages>
        </div>

        <label>
            Account Number:
        </label>
        <input formControlName="accountNumber" class="form-control  form-control-sm" required/>
        <lf-control-messages [control]="form.controls['accountNumber']"></lf-control-messages>

        <p class="text-danger" *ngIf="data.dialogError">
            {{data.dialogError}}
        </p>
    </form>
</mat-dialog-content>

<mat-dialog-actions>
    <button (click)="closeDialog()" class="btn btn-outline-secondary">
        Cancel
    </button>
    <button (click)="handleBankInfo();" [disabled]="!form.valid || (data.verifyPlaid && !selectedSearchResult)"
            class="btn btn-primary"
            type="button">Next
    </button>
</mat-dialog-actions>
